<div class="bs-callout bs-callout-warning" id="callout-glyphicons-location">
  <ng-content selector="h4"></ng-content>
  <p><ng-content></ng-content></p>
</div>
